import { Injectable } from '@angular/core';
import { Observable, catchError, of, switchMap, tap } from 'rxjs';
import { Store } from '../../../../../services/store';
import { toVoid } from '../../../../../utils/void';
import { BomNotesProvider } from './bom-notes.provider';
import { BomNoteDto } from './bom-note.dto';

export interface BomNotesState {
  loading: boolean;
  notes: BomNoteDto[] | undefined;
  saving: boolean;
  saveError: string | undefined;
}

const INITIAL_STATE: BomNotesState = {
  loading: false,
  notes: undefined,
  saving: false,
  saveError: undefined
};

@Injectable({ providedIn: 'root' })
export class BomNotesStore extends Store<BomNotesState> {
  constructor(private provider: BomNotesProvider) {
    super(INITIAL_STATE);
  }

  init(bomItemId: number | undefined): Observable<void> {
    if (bomItemId === undefined) {
      // item not saved in backend yet (/bom/new) — nothing can be noted on it
      this.update(state => ({ ...state, loading: false, notes: [], saveError: undefined }));
      return of(undefined);
    }

    this.update(state => ({ ...state, loading: true, saveError: undefined }));

    return this.provider.getNotes(bomItemId)
      .pipe(
        tap(notes => {
          this.update(state => ({
            ...state,
            loading: false,
            notes
          }));
        }),
        toVoid()
      );
  }

  create(bomItemId: number, content: string): Observable<void> {
    this.update(state => ({ ...state, saving: true, saveError: undefined }));

    return this.provider.createNote(bomItemId, content)
      .pipe(
        tap(() => this.update(state => ({ ...state, saving: false }))),
        switchMap(() => this.init(bomItemId)),
        catchError(error => {
          this.update(state => ({
            ...state,
            saving: false,
            saveError: typeof error.error === 'string' ? error.error : 'Nie udało się zapisać notatki'
          }));
          return of(undefined);
        })
      );
  }
}
